import create from 'zustand'

export const useApiClient = create((set) => ({
    apiClient: null,
    setApiClient: (apiClient) => set((state) => ({ ...state, apiClient })),
}));